import { render, staticRenderFns } from "./GeoTIFFViewer.vue?vue&type=template&id=34c2c8c1&scoped=true&"
import script from "./GeoTIFFViewer.vue?vue&type=script&lang=js&"
export * from "./GeoTIFFViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c2c8c1",
  null
  
)

export default component.exports